import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const Support = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.0001 4.16675C13.5126 4.16675 4.16675 13.5126 4.16675 25.0001V33.6313C4.16675 35.7647 6.0355 37.5001 8.33341 37.5001H10.4167C10.9693 37.5001 11.4992 37.2806 11.8899 36.8899C12.2806 36.4992 12.5001 35.9693 12.5001 35.4167V24.7022C12.5001 24.1496 12.2806 23.6197 11.8899 23.229C11.4992 22.8383 10.9693 22.6188 10.4167 22.6188H8.52508C9.68341 14.5563 16.6209 8.33341 25.0001 8.33341C33.3792 8.33341 40.3167 14.5563 41.4751 22.6188H39.5834C39.0309 22.6188 38.501 22.8383 38.1103 23.229C37.7196 23.6197 37.5001 24.1496 37.5001 24.7022V37.5001C37.5001 39.798 35.6313 41.6667 33.3334 41.6667H29.1667V40.5834C29.1667 40.0311 28.719 39.5834 28.1667 39.5834H21.8334C21.2811 39.5834 20.8334 40.0311 20.8334 40.5834V44.8334C20.8334 45.3857 21.2811 45.8334 21.8334 45.8334H33.3334C37.9292 45.8334 41.6667 42.0959 41.6667 37.5001C43.9647 37.5001 45.8334 35.7647 45.8334 33.6313V25.0001C45.8334 13.5126 36.4876 4.16675 25.0001 4.16675Z"
        fill={color}
      />
    </svg>
  )
}
